import { CREATE_BENEFIT_PACK, CREATE_BENEFIT_PACK_SUCCESS, CREATE_BENEFIT_PACK_ERROR, CREATE_BENEFIT_PACK_EMPTY } from './../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const CreateBenefitPack = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_BENEFIT_PACK:
      state = {
        ...state,
        data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case CREATE_BENEFIT_PACK_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };

      break;

    case CREATE_BENEFIT_PACK_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case CREATE_BENEFIT_PACK_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default CreateBenefitPack;
